import { SvgIcon, SvgIconProps } from '@mui/material';

const TackleBoxOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="TackleBoxOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M9.0008 5V6H14.9992V5H9.0008ZM3.43783 19H7.38307L7.83021 18.1055C8.16892 17.4279 8.86147 17 9.6188 17H14.3812C15.1385 17 15.8311 17.4279 16.1698 18.1055L16.6169 19H20.5622L20.9283 13.5H14.9338C14.7116 14.3623 13.9312 15 12.9997 15H11.0003C10.0688 15 9.28838 14.3623 9.06621 13.5H3.07171L3.43783 19ZM3.0971 11.5H9.38546C9.66001 11.1939 10.0569 11 10.5004 11H13.4996C13.9431 11 14.34 11.1939 14.6145 11.5H20.9029L20.5846 8H3.41537L3.0971 11.5ZM16.9987 6H20.5846C21.6187 6.00007 22.4817 6.78922 22.5753 7.81934L22.9932 12.4092L23 12.4883L22.9951 12.5664L22.5568 19.1328C22.4867 20.1834 21.6148 21 20.5622 21H16.6169C15.8596 21 15.1671 20.5721 14.8283 19.8945L14.3812 19H9.6188L9.17165 19.8945C8.83295 20.5721 8.14039 21 7.38307 21H3.43783C2.45095 21 1.62209 20.2825 1.46472 19.3271L1.44324 19.1328L1.00488 12.5664L1 12.4883L1.00683 12.4092L1.42469 7.81934L1.45105 7.62891C1.62681 6.69342 2.4459 6.00006 3.41537 6H7.00133V5C7.00133 3.89543 7.89652 3 9.0008 3H14.9992C16.1035 3 16.9987 3.89543 16.9987 5V6Z" />
    </SvgIcon>
  );
};

export default TackleBoxOutlined;
